// src/components/auth/AuthWrapper.jsx
import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { AuthProvider } from '../../auth/AuthContext';
import { LeaveProvider } from '../../context/LeaveContext';
import { EstablishmentProvider } from '../../context/EstablishmentContext';
import App from '../../App';
import LoginPage from './LoginPage';

const AuthWrapper = ({ onGoogleSuccess }) => {
  const isMsalAuthenticated = useIsAuthenticated();
  const isGoogleAuthenticated = localStorage.getItem('authProvider') === 'google' && localStorage.getItem('googleCredential');
  const isAuthenticated = isMsalAuthenticated || isGoogleAuthenticated;

  if (isAuthenticated) {
    return (
      <AuthProvider>
        <LeaveProvider>
          <EstablishmentProvider>
            <App />
          </EstablishmentProvider>
        </LeaveProvider>
      </AuthProvider>
    );
  }

  return <LoginPage onGoogleSuccess={onGoogleSuccess} />;
};

export default AuthWrapper;
